<div class="row no-padding">
  <div class="col-md-4 col-left">
    <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
      <mat-label>{{'Land' | translate}}</mat-label>
      <mat-select [(ngModel)]="this.Land" (selectionChange)="landchange()" required placeholder="{{'RequiredPlaceholderSelect' | translate}}" [disabled]="OnlyCH">
        <mat-option  [value]="0">{{'Neuauftrag.Forderung.Land.CH' | translate}}</mat-option>
        <mat-option  [value]="1">{{'Neuauftrag.Forderung.Land.FL' | translate}}</mat-option>
        <mat-option  [value]="2">{{'Neuauftrag.Forderung.Land.DE' | translate}}</mat-option>
        <mat-option  [value]="3">{{'Neuauftrag.Forderung.Land.FR' | translate}}</mat-option>
        <mat-option  [value]="4">{{'Neuauftrag.Forderung.Land.AUT' | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="col-md-4 col-middle">
    <mat-form-field appearance="fill" class="input-field"
      [class.mat-form-field-invalid]="Land == 0 && plzModel.invalid && (plzModel.dirty || plzModel.touched)"
      style="width:100%" floatLabel="always">
      <mat-label [class.required-invalid]="Land == 0 && plzModel.invalid && (plzModel.dirty || plzModel.touched)">{{'PLZ' | translate}}</mat-label>
      <input #plzModel="ngModel" matInput type="text" (input)="checkplz()" [(ngModel)]="Plz" (change)="plzchange()" required
        [attr.minlength]="Land == 0 ? 4 : null"
        [attr.maxlength]="Land == 0 ? 4 : null"
        [attr.pattern]="Land == 0 ? '\\d{4}' : null"
        placeholder="{{'RequiredPlaceholder' | translate}}">
      @if (Land == 0 && plzModel.invalid && (plzModel.dirty || plzModel.touched)) {
        <mat-error>{{'RequiredPlaceholder' | translate}}</mat-error>
      }
    </mat-form-field>
  </div>
  @if (Land == 0) {
    <div class="col-md-4 col-right">
      <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
        <mat-label>{{'Ort' | translate}}</mat-label>
        <mat-select [(ngModel)]="Ort" required placeholder="{{'RequiredPlaceholderSelect' | translate}}" (selectionChange)="ortchange()">
          @for (plzinfo of this.plzinfolisteFilter; track plzinfo) {
            <mat-option [value]="plzinfo.Ort">{{plzinfo.Ort}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @if (Land != 0) {
    <div class="col-md-4 col-right">
      <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
        <mat-label>{{'Ort' | translate}}</mat-label>
        <input matInput type="text" [(ngModel)]="Ort" (change)="ortchange()" required placeholder="{{'RequiredPlaceholder' | translate}}">
      </mat-form-field>
    </div>
  }
</div>

